import { ILanguage } from "../types";

export const el: ILanguage = {
  translation: {
    root: {
      customize: "Προσαρμογή",
      businessAccount: "Επιχειρηματικός λογαριασμός",
      verificationStatus: "Κατάσταση επαλήθευσης",
      companyInformation: "Πληροφορίες της εταιρείας",
      note: "Σημείωμα",
      businessName: "Εμπορική επωνυμία*",
      enterBusinessName: "Εισαγάγετε το όνομα επιχείρησης",
      registrationNumber: "Εταιρεία Reg.",
      registrationNumberPlaceholder: "Εισαγάγετε τον αριθμό εγγραφής",
      taxVat: "Αρ. Καταχώρησης Φορολογίας/ΦΠΑ",
      vatPlaceholder: "Εισαγάγετε τον αριθμό εγγραφής φόρου/ΦΠΑ",
      registeredAddress: "Εγγεγραμμένη διεύθυνση*",
      mode: "Λειτουργία",
      comments: "Σχόλια",
      tradingAddress: "Διεύθυνση συναλλαγών*",
      sameAsRegisteredAddress: "Ίδιο με την εγγεγραμμένη διεύθυνση",
      billingInformation: "Πληροφορίες χρέωσης",
      billingPhoneNo: "Τηλεφωνικό τηλέφωνο Αρ.*",
      phonePlaceholder: "Εισαγάγετε τον αριθμό τηλεφώνου",
      middleName: "Μεσαίο όνομα",
      middleNameLabel: "Μεσαίο όνομα",
      enterMiddleName: "Εισαγάγετε μεσαίο όνομα",
      billingEmail: "Email χρέωσης*",
      emailPlaceholder: "Εισαγάγετε email χρέωσης",
      driverDetails: "Λεπτομέρειες οδηγού",
      customerVerificationStatus: "Κατάσταση επαλήθευσης πελατών:",
      enterNationalInsuranceNumber: "Εισαγάγετε τον αριθμό εθνικής ασφάλισης",
      enterYourProfession: "Εισαγάγετε το επάγγελμά σας",
      enterDriving: "Εισάγετε οδήγηση",
      profileImage: "εικόνα προφίλ",
      number: "Αριθμός",
      image: "Εικών",
      uploadBack: "Μεταφορτώσω",
      uploadFront: "Μεταφορτώστε το μέτωπο",
      issuedBy: "Εκδίδεται από",
      document: "Εγγραφο",
      selectDocument: "Επιλέξτε το έγγραφο",
      addFile: "Προσθέστε αρχείο",
      noDataFound: "Δεν βρέθηκαν δεδομένα",
      noDocumentsFound: "Δεν βρέθηκαν έγγραφα",
      documentUpdatedAt: "Ενημερώθηκε το έγγραφο στο",
      editExpiryDate: "Επεξεργασία ημερομηνίας λήξης",
      selectExpiryDate: "Επιλέξτε Ημερομηνία λήξης",
      selectExpiryDateUpload:
        "Επιλέξτε μια ημερομηνία λήξης πριν από τη μεταφόρτωση.",
      status: "Κατάσταση",
      images: "Εικόνες",
      profession: "Επάγγελμα",
      nationality: "Ιθαγένεια",
      driving: "Οδήγηση",
      listOfDocumentsUploaded: "Κατάλογος των εγγράφων που μεταφορτώθηκαν",
      listOfRequiredDocumentsUploaded:
        "Κατάλογος των απαιτούμενων εγγράφων που μεταφορτώθηκαν",
      documentType: "Τύπος εγγράφου",
      documentName: "Όνομα εγγράφου",
      expiryDate: "Ημερομηνία λήξης",
      confirmDelete: "Επιβεβαιώστε τη διαγραφή",
      actions: "Ενέργειες",
      completed: "Ολοκληρώθηκε το",
      pending: "Εκκρεμής",
      documentDeleteConfirmMsg:
        "Είστε βέβαιοι ότι θέλετε να διαγράψετε αυτό το έγγραφο;",
      address: "Διεύθυνση",
      useRegisteredAddress: "Χρήση εγγεγραμμένης διεύθυνσης",
      billingEmailAddress: "Διεύθυνση email χρέωσης*",
      billingEmailLabel: "Διεύθυνση email χρέωσης",
      accountNumber: "Αριθμός λογαριασμού",
      firstName: "Ονομα*",
      firstNameLabel: "Ονομα",
      lastName: "Επώνυμο*",
      lastNameLabel: "Επώνυμο",
      contactEmail: "Επικοινωνήστε με τη διεύθυνση email*",
      emailLabel: "Διεύθυνση email",
      contactPhone: "Επικοινωνήστε με το τηλέφωνο Αρ.*",
      registeredAddressCaps: "Εγγεγραμμένη διεύθυνση",
      tradingAddressCaps: "Διεύθυνση συναλλαγών",
      billingInformationCaps: "Πληροφορίες χρέωσης",
      customerContactCaps: "Επαφή με τον πελάτη",
      contactEmailInvalid: "Εισαγάγετε ένα έγκυρο email επικοινωνίας.",
      typeAddress: "Διεύθυνση τύπου",
      taxFees: "Φόροι και αμοιβές",
      vatTax: "ΦΠΑ/Φόρος",
      registrationNum: "Αριθμός εγγραφής",
      drivingLicenceNumber: "Αριθμός άδειας οδήγησης",
      invalidPhoneNumber: "Μη έγκυρος αριθμός τηλεφώνου",
      onStartEmail:
        "Σας έχουμε στείλει μέσω ηλεκτρονικού ταχυδρομείου για το πώς να ξεκινήσετε.",
      emailNotSeen:
        'Εάν δεν βλέπετε το μήνυμα ηλεκτρονικού ταχυδρομείου σε λίγα λεπτά, ελέγξτε το "ανεπιθύμητο φάκελο" ή το "SPAM Folder.',
      registerNow: "Εγγραφείτε τώρα",
      email: "Ηλεκτρονικό ταχυδρομείο",
      thankYou: "Ευχαριστώ",
      pickUpLocation: "Τοποθεσία παραλαβής ",
      returnLocation: "Τοποθεσία επιστροφής *",
      pickUpDate: "Ημ. παραλαβής *",
      pickUpTime: "Ώρα παραλαβής *",
      invalidPickupLeadTime: "Η επιλεγμένη ημερομηνία/ώρα παραλαβής είναι εκτός του επιτρεπόμενου παραθύρου κράτησης",
      dropOffDate: "παράδοσης Ημ. *",
      searchVehicles: "Αναζήτηση οχημάτων",
      chooseLocation: "Εισαγάγετε μια τοποθεσία ή ταχυδρομικό κώδικα",
      vehicleGallery: "Συλλογή οχημάτων",
      privacyPolicy: "Πολιτική απορρήτου",
      termsAndConditions: "Όροι και προϋποθέσεις",
      dropOffTime: "Ώρα παράδοσης *",
      noVehiclesFound:
        "Δεν βρέθηκαν οχήματα που να πληρούν τα επιλεγμένα κριτήρια",
      noRecordFound: "Λυπούμαστε, δεν βρέθηκαν αντίστοιχες εγγραφές!",
      vehicles: "Οχήματα",
      endDate: "Ημερομηνία Λήξης",
      startDate: "Ημερομηνία Έναρξης",
      past: "Παρελθόν",
      search: "Αναζήτηση",
      upcoming: "Επερχόμενο",
      current: "Τρέχον",
      all: "Όλα",
      more: "Περισσότερα",
      toBeAssigned: "Προς ανάθεση",
      ref: "αναφ",
      reservation: "Κράτηση",
      booking: "Κράτηση",
      pricingSummary: "Περίληψη Τιμολόγησης",
      bookingSummary: "Περίληψη Κράτησης",
      subscriptionVehicle: "Όχημα Συνδρομής",
      insurance: "Ασφάλιση",
      addons: "Πρόσθετα",
      protectionPlan: "Σχέδιο Προστασίας",
      initialRental: "Αρχική Πληρωμή Ενοικίασης",
      enrollmentFee: "Τέλος Εγγραφής",
      quantity: "Ποσότητα",
      subscriptionPrice: "Τιμή Συνδρομής",
      weekly: "Εβδομαδιαία",
      monthly: "Μηνιαία",
      on: "Σε",
      numberOfDoors: "αριθμόςΠορτών",
      numberOfSeats: "αριθμόςΚαθισμάτων",
      transmission: "μετάδοση",
      fuelType: "τύποςΚαυσίμου",
      week: "Εβδομάδα",
      day: "Ημέρα",
      hour: "Ώρα",
      month: "Μήνας",
      gropu1Icon: "εικονίδιο group1",
      vatInclusive: "ΠΕΡΙΛΑΜΒΑΝΕΤΑΙ ΦΠΑ",
      vat: "ΦΠΑ",
      rental: "Ενοικίαση",
      speedometer: "ταχύμετρο",
      available: "Διαθέσιμο",
      priceLowToHigh: "Τιμή από χαμηλή σε υψηλή",
      priceHighToLow: "Τιμή από υψηλή σε χαμηλή",
      weHaveSmartCars: "Διαθέτουμε έξυπνα αυτοκίνητα",
      keylessSupport:
        "Παρέχουμε υποστήριξη εισόδου χωρίς κλειδί με τα έξυπνα αυτοκίνητά μας",
      keylessVehicles: "Προβολή Οχημάτων Χωρίς Κλειδί",
      duration: "Διάρκεια",
      swapsAllowed: "Επιτρέπονται Αντικαταστάσεις",
      enrollmentAmount: "Ποσό Εγγραφής",
      subscriptionAmount: "Ποσό Συνδρομής",
      mileageLimit: "Όριο Χιλιομέτρων",
      unlimited: "Απεριόριστο",
      weeks: "Εβδομάδες",
      months: "Μήνες",
      pricePerExtraMile: "Τιμή ανά επιπλέον μίλι",
      insurancePolicy: "Ασφαλιστήριο Συμβόλαιο",
      removeSubscription: "Αφαίρεση Συνδρομής",
      noGroupFound: "Δεν βρέθηκαν ομάδες με αντίστοιχα κριτήρια!",
      vehicleTypeIcon: "εικονίδιο τύπου οχήματος",
      min: "Ελάχ.",
      selected: "Επιλεγμένο",
      vehiclesSelected: "Επιλεγμένα Οχήματα",
      selectVehicles: "Επιλέξτε Οχήματα",
      personalDetails: "Προσωπικά Στοιχεία",
      selectAddons: "Επιλέξτε Πρόσθετα",
      continue: "Συνέχεια",
      locationSurcharge: "Επιβάρυνση Τοποθεσίας",
      onTotalRentalAmount: "Στο Συνολικό Ποσό Ενοικίασης",
      oneWayFee: "Εφάπαξ Χρέωση",
      oneWayRentalCharge: "Εφάπαξ Χρέωση Ενοικίασης",
      total: "Σύνολο",
      firstMonthTotal: "Σύνολο Πρώτου Μήνα",
      firstWeekTotal: "Σύνολο Πρώτης Εβδομάδας",
      depositPayable: "Κατάθεση (Πληρωτέα κατά την παραλαβή)",
      deposit: "Κατάθεση",
      insuranceCaps: "ΑΣΦΑΛΕΙΑ",
      customAddon: "προσαρμοσμένο πρόσθετο",
      chooseAPolicy: "Επιλέξτε Πολιτική",
      rate: "Τιμή",
      typeOfValet: "Τύπος Παρκαδόρου",
      nonNegotiable: "Μη διαπραγματεύσιμο",
      selectValet: "Επιλέξτε Παρκαδόρο",
      collectionAddress: "Διεύθυνση Παραλαβής",
      remove: "Αφαίρεση",
      deliveryAddress: "Διεύθυνση Παράδοσης",
      additionalInformation: "Πρόσθετες Πληροφορίες",
      confirmBooking: "Επιβεβαίωση Κράτησης",
      proceed: "Συνέχεια",
      getQuote: "Λήψη Προσφοράς",
      for: "για",
      agreeWithTermsAndConditions: "Συμφωνώ με τους όρους και τις προϋποθέσεις",
      selectCostCenter: "Επιλέξτε Κέντρο Κόστους για Κράτηση",
      action: "Ενέργεια",
      name: "Όνομα",
      enterDrivingLicenceNumber: "Εισάγετε Αριθμό Άδειας Οδήγησης",
      enterLastName: "Εισάγετε Επώνυμο",
      enterFirstName: "Εισάγετε Όνομα",
      enterYourMail: "Εισάγετε το email σας",
      emailAsterisk: "Email*",
      quoteGeneratedCaps: "ΠΡΟΣΦΟΡΑ ΔΗΜΙΟΥΡΓΗΘΗΚΕ",
      updated: "ενημερώθηκε",
      rentalCharges: "Χρεώσεις Ενοικίασης",
      totalPayableAmount: "Συνολικό Πληρωτέο Ποσό",
      payMinimumAmount: "Πληρωμή ελάχιστου ποσού",
      dueAmountPaidWhilePickup:
        "Το οφειλόμενο ποσό καταβάλλεται κατά την παραλαβή",
      payOnCollection: "Πληρωμή κατά την παραλαβή",
      CardAuthorization:
        "Η κάρτα θα εγκριθεί τώρα αλλά το ποσό θα αφαιρεθεί όταν",
      starts: "ξεκινάει",
      confirm: "Επιβεβαίωση",
      payAtTimeOfPickup: "τώρα και πληρωμή κατά την παραλαβή",
      payFullAmountNow: "Πλήρης Πληρωμή Τώρα",
      payFullAmountRightAway: "Πλήρης Πληρωμή Άμεσα",
      FutureChargesRelatedToOngoingBooking:
        "Μελλοντικές χρεώσεις σχετικές με την τρέχουσα κράτηση θα χρεωθούν σε αυτή τη μέθοδο πληρωμής",
      saveThisCardForFutureInvoices:
        "Αποθηκεύστε αυτήν την κάρτα για μελλοντικές πληρωμές τιμολογίων {{bookingSyntax}}",
      payLater: "Πληρωμή Αργότερα",
      creditLimitAssigned:
        "Το εκχωρηθέν πιστωτικό όριο θα χρησιμοποιηθεί για αυτή την πληρωμή",
      CreditsAgainstBooking:
        "Πιστώσεις θα χρησιμοποιηθούν για αυτή την κράτηση",
      useCreditNoteBalance: "Χρήση Υπολοίπου Πιστωτικού Σημειώματος",
      telNo: "Τηλ.",
      vatNo: "ΑΦΜ",
      customer: "Πελάτης",
      emailAddress: "Διεύθυνση Email",
      phoneNumber: "Αριθμός Τηλεφώνου",
      dateCreated: "Ημερομηνία Δημιουργίας",
      poNumber: "Αρ. Παραγγελίας",
      dateTime: "Ημερομηνία & Ώρα",
      dropOffLocation: "Τοποθεσία Παράδοσης",
      contractHire: "Μίσθωση Συμβολαίου",
      subscription: "Συνδρομή",
      charges: "Χρεώσεις",
      enrollmentFees: "Τέλη Εγγραφής",
      na: "Μ/Δ",
      grandTotal: "Γενικό Σύνολο",
      rentalPrice: "Τιμή Ενοικίασης",
      daysProRated: "ημέρες αναλογικά",
      locationSurcharges: "Επιπλέον Χρεώσεις Τοποθεσίας",
      ofTotalRentalAmount: "του συνολικού ποσού ενοικίασης",
      nextBilling: "Επόμενη Χρέωση",
      subTotal: "Υποσύνολο",
      discount: "Έκπτωση",
      discountedPrice: "Εκπτωτική Τιμή",
      description: "ΠΕΡΙΓΡΑΦΗ",
      descriptionLabel: "Περιγραφή",
      thisIsA: "Αυτό είναι",
      exemptedBooking: "εξαιρούμενη κράτηση",
      thisIstestCourtsey: "Αυτό είναι δοκιμή/ευγένεια",
      isCalculatedAgainst: "υπολογίζεται έναντι",
      priceAndSelectedAddons:
        "Τιμή και επιλεγμένα πρόσθετα (εκτός Ασφάλειας και Κατάθεσης)",
      recurringWeeklyMonthlyInvoice:
        "Θα δημιουργείται αυτόματα περιοδικό τιμολόγιο εβδομαδιαία/μηνιαία.",
      additionalNote: "Πρόσθετη Σημείωση",
      payableAtVehicleCollection: "Πληρωτέο κατά την παραλαβή οχήματος",
      purchaseOrderUpdated: "ο αριθμός εντολής αγοράς ενημερώθηκε επιτυχώς",
      proceedToPay: "Συνέχεια στην πληρωμή",
      searchResults: "Αποτελέσματα αναζήτησης",
      subscriptions: "Συνδρομές",
      contractHireVehicleWeeklyMonthly:
        "Ενοικίαση οχήματος για εβδομαδιαία/μηνιαία χρήση",
      subscribeVehicleWeeklyMonthly:
        "Εγγραφή οχήματος για εβδομαδιαία/μηνιαία χρήση",
      contractNow: "Σύναψε συμβόλαιο τώρα",
      subscribeNow: "Εγγράψου τώρα",
      backToBookingCategorySelection:
        "Επιστροφή στην επιλογή κατηγοριών κράτησης.",
      accountVerification: "Επαλήθευση λογαριασμού",
      profileNotVerifiedMessage:
        "Το προφίλ σας δεν έχει επαληθευτεί. Παρακαλώ επικοινωνήστε με τον διαχειριστή σας για να ολοκληρώσετε τη διαδικασία επαλήθευσης και να συνεχίσετε.",
      update: "Ενημέρωση",
      reference: "Αναφορά",
      companyRegistrationNumber: "Αριθμός μητρώου Co",
      availableFrom: "Διαθέσιμο από",
      paellaDish: "Πιάτο παέγια",
      vehicleCatalogues: "Κατάλογοι Οχημάτων",
      vehicleDetails: "Λεπτομέρειες Οχήματος",
      verification: "Επαλήθευση",
      protectionPlans: "Σχέδια προστασίας",
      authorisedSignatory: "Εξουσιοδοτημένος Υπογράφων",
      item: "Είδος",
      price: "Τιμή",
      unitPrice: "Τιμή μονάδας",
      vehicleSpecification: "Προδιαγραφές οχήματος",
      model: "Μοντέλο",
      color: "Χρώμα",
      bodyType: "Τύπος αμαξώματος",
      tankCapacity: "Χωρητικότητα δεξαμενής",
      interiorColor: "Εσωτερικό χρώμα",
      seats: "Καθίσματα",
      doors: "Πόρτες",
      whatsIncluded: "Τι περιλαμβάνεται",
      timeVehicleSwap: "χρόνος αλλαγής οχήματος",
      contractualDetails: "Στοιχεία συμβολαίου",
      longerSubscribeSaveMore:
        "Όσο περισσότερο εγγράφεστε, τόσο περισσότερο εξοικονομείτε",
      tailorSubscriptionToNeeds: "Προσαρμόστε τη συνδρομή στις ανάγκες σας",
      easyManagementOnline: "Διαχειριστείτε εύκολα και διαδικτυακά",
      SwapCarAndCancel: "Ανταλλάξτε ή ακυρώστε οποιαδήποτε στιγμή",
      customizeYourContract: "Προσαρμόστε το συμβόλαιό σας",
      selectPlan: "Επιλέξτε πλάνο",
      selectTenure: "Επιλέξτε διάρκεια",
      tentativeStartDate: "Προσωρινή ημερομηνία έναρξης",
      selectDate: "Επιλέξτε ημερομηνία",
      selectTime: "Επιλέξτε ώρα",
      contractSummary: "Περίληψη συμβολαίου",
      subscriptionChargesLabel: "Χρεώσεις συνδρομής",
      initialRentalPayment: "Αρχική πληρωμή ενοικίασης",
      continueToPersonalDetails: "Συνεχίστε στα προσωπικά στοιχεία",
      noAvailableAddonsFound:
        "Δεν βρέθηκαν διαθέσιμα πρόσθετα που να ταιριάζουν με τα κριτήρια αναζήτησής σας",
      nationalInsuranceNumber: "Εθνικός αριθμός ασφάλισης",
      updateQuote: "Ενημέρωση Προσφοράς",
      driverNotAvailable:
        "Ο οδηγός δεν είναι διαθέσιμος, επικοινωνήστε με τον πάροχο ενοικίασης",
      selectDeliverySlot: "Επιλέξτε Χρονικό Διάστημα Παράδοσης",
      wantDelivered: "Θέλετε να παραδοθεί;",
      verifyYourLicenceCaps: "ΕΠΙΒΕΒΑΙΩΣΤΕ ΤΗΝ ΑΔΕΙΑ ΣΑΣ",
      validateAllFieldsForLicenceCheck:
        "Παρακαλώ επιβεβαιώστε ή εισαγάγετε τα παρακάτω στοιχεία για να προχωρήσετε στον έλεγχο άδειας. Όλα τα πεδία είναι υποχρεωτικά",
      postCode: "Ταχυδρομικός Κώδικας",
      thisAgreementAllows: "Αυτή η συμφωνία επιτρέπει",
      leftoverAgreement:
        "και στον ασφαλιστικό μας συνεργάτη να πραγματοποιήσει ελέγχους στην άδεια οδήγησης σας και να μεταβιβάσει τα δεδομένα σας σε ασφαλιστικές και άλλους τρίτους (Coastr) για διαχείριση της ενοικίασης, της ασφάλισης κ.λπ. Συμφωνείτε;",
      verifyLicence: "Επιβεβαίωση Άδειας",
      licenceCheckingInProgress: "Έλεγχος άδειας σε εξέλιξη",
      checkingInProgress:
        "Μπορεί να διαρκέσει έως 2 λεπτά, περιμένετε και μην κλείσετε το πρόγραμμα περιήγησης",
      licenceCheckingFailed: "Ο έλεγχος άδειας απέτυχε",
      checkForCorrectDetails: "Ελέγξτε αν εισαγάγατε σωστά τα στοιχεία.",
      tryAgainLater: "Αν το πρόβλημα παραμένει, δοκιμάστε ξανά αργότερα.",
      licenceCheckedSuccessfully: "Η άδεια επαληθεύτηκε με επιτυχία",
      licenceSummaryAdded: "Η σύνοψη άδειας προστέθηκε στο προφίλ πελάτη",
      creditScore: "Πιστωτική Βαθμολογία",
      lastChecked: "Τελευταίος Έλεγχος",
      recheckCreditScore: "ΕΠΑΝΑΛΗΠΤΙΚΟΣ ΕΛΕΓΧΟΣ ΠΙΣΤΟΛΗΠΤΙΚΗΣ ΙΚΑΝΟΤΗΤΑΣ",
      checkCreditScore: "ΕΛΕΓΧΟΣ ΠΙΣΤΟΛΗΠΤΙΚΗΣ ΙΚΑΝΟΤΗΤΑΣ",
      proceedToPayment: "Συνέχεια στην Πληρωμή",
      paymentOverview: "Επισκόπηση πληρωμής",
      schedule: "Πρόγραμμα",
      contractDetails: "Λεπτομέρειες συμβολαίου",
      plan: "Πλάνο",
      swaps: "Αντικαταστάσεις",
      payableDeposit: "Πληρωτέα προκαταβολή",
      customerVerification: "Επαλήθευση πελάτη",
      provideAdditionalDetails:
        "Παρακαλώ δώστε τα παρακάτω επιπλέον στοιχεία στην ενότητα λογαριασμού για να δημιουργήσετε κράτηση",
      profilePhoto: "Φωτογραφία προφίλ",
      submitYourRequest:
        "Αφού τελειώσετε, υποβάλετε το αίτημά σας για έγκριση κάνοντας κλικ στο κουμπί υποβολής παρακάτω",
      submit: "Υποβολή",
      uploadLicenceImages: "Ανέβασμα εικόνων άδειας οδήγησης",
      add: "Προσθήκη",
      uploadFrontBackLicence:
        "Ανεβάστε εμπρός και πίσω εικόνα της άδειας. Υποστηριζόμενες μορφές αρχείων: .png, .jpeg, .jpg!",
      uploadLicenceImage: "Ανέβασμα εικόνας άδειας",
      authority: "Αρχή",
      drivingLicenceExpiryDate: "Ημερομηνία λήξης άδειας οδήγησης",
      licenceNumber: "Αριθμός άδειας",
      preview: "Προεπισκόπηση",
      addOn: "Πρόσθετο",
      contact: "Επικοινωνία",

      selectSlot: "Επιλέξτε Χρονοθυρίδα",
      deliveryType: "Τύπος Παράδοσης",
      experience: "Εμπειρία",
      type: "Τύπος",
      bookATestDrive: "Κλείστε Δοκιμαστική Οδήγηση",
      selectASlot: "Επιλέξτε Χρονοθυρίδα",
      selectDateTimeSlot: "Επιλέξτε Ημερομηνία και Ώρα",
      vehicleNotAvailable:
        "Το όχημα δεν είναι διαθέσιμο για την επιλεγμένη ημερομηνία",
      selectDifferentDate: "Παρακαλώ επιλέξτε διαφορετική ημερομηνία",
      selectCar: "Επιλέξτε Όχημα",
      availableNow: "Διαθέσιμο Τώρα",
      new: "Νέο",
      phone: "Τηλέφωνο",
      customerDetails: "Στοιχεία Πελάτη",
      dealershipAddress: "Διεύθυνση Αντιπροσωπείας",
      dealership: "Αντιπροσωπεία",
      bookingTime: "Ώρα Κράτησης",
      bookingType: "Τύπος Κράτησης",
      details: "Λεπτομέρειες",
      your: "Σας",
      confirmation: "Επιβεβαίωση",
      selectDealership: "Επιλέξτε Αντιπροσωπεία",
      testDriveRequested: "Αιτήθηκε Δοκιμαστική Οδήγηση",
      testDrive: "Δοκιμαστική Οδήγηση",
      mobileNumber: "Αριθμός Κινητού",
      drivingLicenseNumber: "Αριθμός Διπλώματος Οδήγησης",
      enterLicenseNumber: "Εισάγετε Αριθμό Διπλώματος",
      requestTestDrive: "Αίτηση για Δοκιμή",
      slot: "σχισμή",
      vehicle: "Όχημα",
      selectSubsctiption: "ΕΠΙΛΟΓΗ ΣΥΝΔΡΟΜΗΣ",
      pricesShownOnSelectedDuration:
        "Οι τιμές εμφανίζονται βάσει της επιλεγμένης διάρκειας",
      priceComparison: "Σύγκριση Τιμών",
      oneTime: "Μία Φορά",
      subscriptionStartsAt: "Η συνδρομή ξεκινά από",
      paymentProcessing: "Επεξεργασία Πληρωμής",
      pleaseWait: "Παρακαλώ περιμένετε",
      paymentComplete: "Η πληρωμή ολοκληρώθηκε",
      paymentInProgress: "Η πληρωμή βρίσκεται σε εξέλιξη",
      atleastUploadOne: "Ανεβάστε τουλάχιστον ένα",
      upload: "Μεταφόρτωση",
      uploadServiceNotAvailable: "Η υπηρεσία μεταφόρτωσης δεν είναι διαθέσιμη. Παρακαλώ δοκιμάστε ξανά.",
      uploading: "Μεταφόρτωση...",
      atDealership: "Στην αντιπροσωπεία",
      atHome: "Στο σπίτι",

      enterYourEmailPassword:
        "Εισάγετε το email και τον κωδικό σας για να συνδεθείτε",
      enterMailHere: "Εισάγετε το email σας εδώ",
      required: "Απαιτείται",
      password: "Κωδικός πρόσβασης",
      reset: "Επαναφορά",
      otpForPasswordReset:
        "Θα λάβετε έναν κωδικό OTP στο email σας για επαναφορά κωδικού",
      sendOtp: "Αποστολή OTP",
      loginInstead: "Συνδεθείτε αντί αυτού",
      verifyOtp: "Επαλήθευση OTP",
      otp: "OTP",
      otpSentToEmail: "Ο κωδικός OTP έχει σταλεί στο email σας",
      enterOtp: "Εισάγετε τον OTP",
      enterOtpHere: "Εισάγετε τον OTP εδώ",
      verify: "Επαλήθευση",
      setNewPassword: "Ορισμός νέου κωδικού",
      eightCharLong: "Πρέπει να είναι 8 χαρακτήρων",
      reenterPassword: "Εισάγετε ξανά τον κωδικό εδώ",
      signInAs: "Συνδεθείτε ως",
      as: "Ως",
      selectAccountToProceed: "Επιλέξτε λογαριασμό για να συνεχίσετε",
      personalAccount: "Προσωπικός λογαριασμός",
      asBusinessCustomer: "Ως επιχειρηματίας",
      asDriver: "Ως οδηγός",
      enterPassword: "Εισάγετε τον κωδικό εδώ",
      registerAs: "Εγγραφή ως",
      individual: "Ιδιώτης",
      business: "Επιχείρηση",
      operatorMandatedCustomerCheck:
        "Ο πάροχος απαιτεί έλεγχο πελάτη πριν τη επιβεβαίωση κράτησης. Περιμένετε έγκριση.",
      createAccount: "Δημιουργία λογαριασμού",
      emailedHowToGetStarted:
        "Σας στείλαμε οδηγίες για να ξεκινήσετε στο email σας.",
      ifDontSeeEmail:
        "Αν δεν το δείτε σε λίγα λεπτά, ελέγξτε τον φάκελο spam ή ανεπιθύμητης αλληλογραφίας.",
      previousVehicleDetails: "Προηγούμενες πληροφορίες οχήματος",
      registration: "Άδεια κυκλοφορίας",
      makeModel: "Μάρκα/Μοντέλο",
      vin: "Αριθμός VIN",
      driverAssigned: "Οδηγός ανατέθηκε",
      currentVehicleDetails: "Στοιχεία τρέχοντος οχήματος",
      priceGroup: "Ομάδα τιμής",
      unlimitedMileage: "Απεριόριστα χιλιόμετρα",
      paymentStatus: "Κατάσταση πληρωμής",
      invoiceNumber: "Αριθμός τιμολογίου",
      deliveryDetails: "Στοιχεία παράδοσης",
      collectionDetails: "Στοιχεία παραλαβής",
      coiDetails: "Στοιχεία COI",
      policyName: "Όνομα πολιτικής",
      planName: "Όνομα σχεδίου",
      policyNumber: "Αριθμός πολιτικής",
      provider: "Πάροχος",
      vehicleSwapDetails: "Στοιχεία ανταλλαγής οχήματος",
      swapMyCar: "Ανταλλαγή οχήματος",
      NoOfSwapsAllowed: "Επιτρεπόμενες ανταλλαγές",
      NoOfSwapsAvailed: "Χρησιμοποιημένες ανταλλαγές",
      NoOfSwapsRemaining: "Υπολειπόμενες ανταλλαγές",
      swapRequestHistory: "ΙΣΤΟΡΙΚΟ ΑΙΤΗΣΕΩΝ ΑΝΤΑΛΛΑΓΗΣ",
      requestedOn: "ΑΙΤΗΘΗΚΕ ΣΤΙΣ",
      swapDate: "ΗΜΕΡΟΜΗΝΙΑ ΑΝΤΑΛΛΑΓΗΣ",
      oldVehicle: "Παλιό όχημα",
      newVehicle: "Νέο όχημα",
      addonsDetails: "Λεπτομέρειες πρόσθετων",
      paymentDetails: "Λεπτομέρειες πληρωμής",
      billingPeriod: "Περίοδος χρέωσης",
      creationDate: "Ημερομηνία δημιουργίας",
      invoiceType: "Τύπος τιμολογίου",
      regular: "Κανονικό",
      depositDetails: "Λεπτομέρειες κατάθεσης",
      amount: "Ποσό",
      totalPaidAmount: "Συνολικό καταβληθέν ποσό",
      cancellationCharges: "Χρεώσεις ακύρωσης",
      totalRefundAmount: "Συνολικό επαναβεβαιωμένο ποσό",
      anUnpaid: "απλήρωτο",
      aPartiallyPaid: "μερικώς πληρωμένο",
      thisIs: "Αυτό είναι",
      pleaseContactUs:
        "Παρακαλούμε επικοινωνήστε μαζί μας για περαιτέρω ερωτήσεις",
      reasonToCancelTheBooking: "Επιλέξτε λόγο ακύρωσης κράτησης",
      enterTheReason: "Εισάγετε τον λόγο",
      dismiss: "Απόρριψη",
      selectVehicle: "Επιλέξτε όχημα",
      bookingConfirmationInProgress: "Επιβεβαίωση κράτησης σε εξέλιξη",
      pleaseProvideTheReason: "Παρακαλώ δώστε τον λόγο",
      quote: "Προσφορά",
      management: "Διαχείριση",
      pickupDateTimePassed: "Η ώρα παραλαβής έχει περάσει ή είναι χωρίς χρέωση",
      profileRejectedOrPending:
        "Το προφίλ σας έχει απορριφθεί ή βρίσκεται σε εκκρεμότητα",
      testDriveAgreement: "Συμφωνία δοκιμαστικής οδήγησης",
      rentalAgreement: "Συμφωνία ενοικίασης",
      contractHireAgreement: "Συμφωνία μίσθωσης συμβολαίου",
      subscriptionAgreement: "Συμφωνία συνδρομής",
      zeroChargeBooking:
        "Οι κρατήσεις χωρίς χρέωση επιβεβαιώνονται μόνο από τον πάροχο",
      pickupDateTimeInPast: "Η ώρα παραλαβής είναι στο παρελθόν",
      creditNoteSummary: "Περίληψη πιστωτικής σημείωσης",
      customerName: "Όνομα πελάτη",
      customerEmail: "Email πελάτη",
      creditNoteRef: "Αναφορά πιστωτικής σημείωσης",
      invoiceRef: "Αναφορά τιμολογίου",
      totalAmount: "Συνολικό ποσό",
      amountAdjustedRefunded: "Ρυθμισμένο/Επιστραφέν ποσό",
      amountAvailable: "Διαθέσιμο ποσό",
      adjustments: "Ρυθμίσεις",
      particulars: "Στοιχεία",
      adjustedToInvoice: "Ρυθμίστηκε στο τιμολόγιο",
      adjustedAt: "Ρυθμίστηκε στις",
      creditNotes: "Πιστωτικές σημειώσεις",
      availableBalance: "Διαθέσιμο υπόλοιπο",
      searchCreditNoteId: "Αναζήτηση ID πιστωτικής σημείωσης",
      active: "Ενεργό",
      exhausted: "Εξαντλήθηκε",
      creditNoteId: "ID πιστωτικής σημείωσης",
      dateGenerated: "Ημερομηνία δημιουργίας",
      amountRefunded: "Επιστραφέν ποσό",
      amountRemaining: "Υπόλοιπο",
      dashboard: "Πίνακας ελέγχου",
      activeVehiclesCount: "Αριθμός ενεργών οχημάτων",
      totalActiveBookings: "Σύνολο ενεργών κρατήσεων",
      totalVehicles: "Σύνολο οχημάτων",
      vehicleChecks: "Έλεγχοι οχήματος",
      inProgressBookings: "Κρατήσεις σε εξέλιξη",
      vehicleChecksCompleted: "Ολοκληρωμένοι έλεγχοι οχήματος",
      vehicleChecksPending: "Εκκρεμείς έλεγχοι οχήματος",
      dailyBalance: "Ημερήσιο υπόλοιπο",
      totalOutstanding: "Συνολικό υπόλοιπο",
      UnpaidInvoices: "Αριθμός απλήρωτων τιμολογίων",
      regularInvoices: "Κανονικά τιμολόγια",
      sundryInvoices: "Διάφορα τιμολόγια",
      addNewDriver: "Προσθήκη νέου οδηγού",
      phoneNo: "Τηλέφωνο",
      drivingLicenceImage: "Εικόνα άδειας οδήγησης",
      licenceIssuedBy: "Άδεια εκδόθηκε από",
      licenceExpiryDate: "Ημερομηνία λήξης άδειας",
      drivingLicenceIssueDate: "Ημερομηνία έκδοσης άδειας οδήγησης",
      pcoIssueDate: "Ημερομηνία έκδοσης άδειας PCO οδηγού",
      dateOfBirth: "Ημερομηνία γεννήσεως",
      taskDetailsNotFound: "Δεν βρέθηκαν λεπτομέρειες εργασίας.",
      bookingRef: "Αναφορές κράτησης",
      rateYourExperience: "Αξιολογήστε την εμπειρία σας",
      driverInformation: "Πληροφορίες οδηγού",
      saveDrivers: "Αποθήκευση οδηγών",
      expiry: "Λήξη",
      areYouSureDriver:
        "Είστε βέβαιοι ότι θέλετε να αφαιρέσετε αυτό τον οδηγό;",
      drivers: "Οδηγοί",
      noDriverFound: "Δυστυχώς, δεν βρέθηκε κανένας οδηγός!",
      invoices: "Τιμολόγια",
      searchInvoiceId: "Αναζήτηση ID τιμολογίου",
      unpaid: "Απλήρωτο",
      paid: "Πληρώθηκε",
      void: "Άκυρο",
      invoiceId: "ID τιμολογίου",
      invoiceDate: "Ημερομηνία τιμολογίου",
      balanceDue: "Οφειλόμενο υπόλοιπο",
      dueDate: "Ημερομηνία λήξης",
      invoiceSummary: "Περίληψη τιμολογίου",
      invoice: "Τιμολόγιο",
      sundry: "Διάφορα",
      addPayment: "Προσθήκη πληρωμής",
      customerPhoneNumber: "Τηλέφωνο πελάτη",
      invoiceReference: "Αναφορά τιμολογίου",
      period: "Περίοδος",
      invoiceVoidedBy: "Το τιμολόγιο ακυρώθηκε από",
      invoicePeriod: "Περίοδος τιμολογίου",
      invoiceStatus: "Κατάσταση τιμολογίου",
      invoiceAmount: "Ποσό τιμολογίου",
      amountDue: "Οφειλόμενο ποσό",
      generatedAt: "Δημιουργήθηκε στις",
      vehicleRentalCharges: "Χρεώσεις ενοικίασης οχήματος",
      refundable: "Επιστρέψιμο",
      date: "Ημερομηνία",
      thisIsTestCourtsey: "Αυτή είναι μια δοκιμή/έκπτωση",
      invoicesConsolidated: "Τιμολόγια ενοποιημένα",
      payments: "Πληρωμές",
      exempted: "Εξαιρούμενο",
      pleaseLoginFirst: "Παρακαλούμε συνδεθείτε πρώτα",
      account: "Λογαριασμός",
      tracking: "Παρακολούθηση",
      uploadImages: "Ανέβασμα εικόνων",
      updateVehicleState: "Ενημέρωση κατάστασης οχήματος",
      vehicleImage: "Εικόνα οχήματος",
      fuelStatus: "Κατάσταση καυσίμου",
      batteryStatus: "Κατάσταση μπαταρίας",
      odometerReading: "Καταγραφή χιλιομέτρων",
      nextServiceDetails: "Λεπτομέρειες επόμενης συντήρησης",
      serviceType: "Τύπος υπηρεσίας",
      serviceStatus: "Κατάσταση υπηρεσίας",
      appointmentDate: "Ημερομηνία ραντεβού",
      estdCompletionDate: "Εκτιμ. ημερομηνία ολοκλήρωσης",
      serviceProviderName: "Όνομα παρόχου υπηρεσίας",
      serviceProviderAddress: "Διεύθυνση παρόχου",
      notesForDriver: "Σημειώσεις για τον οδηγό",
      exteriorDamages: "Εξωτερικές ζημιές",
      interiorDamages: "Εσωτερικές ζημιές",
      generalChecks: "Γενικοί έλεγχοι",
      accessoriesChecks: "Έλεγχοι εξοπλισμού",
      chooseFuelLevel: "Επιλέξτε επίπεδο καυσίμου",
      lastReported: "Τελευταία αναφορά",
      circumstance: "Περίσταση",
      title: "Τίτλος",
      damageKind: "Τύπος ζημιάς",
      damageArea: "Περιοχή ζημιάς",
      referenceNumber: "Αριθμός αναφοράς",
      damageDetail: "Λεπτομέρεια ζημιάς",
      addImage: "Προσθήκη εικόνας",
      addImages: "Προσθήκη εικόνων",
      done: "Έγινε",
      searchExistingDriver: "Αναζήτηση υπάρχοντος οδηγού",
      success: "Επιτυχία",
      assignDriver: "Ανάθεση οδηγού",
      plate: "Πινακίδα",
      unassigned: "Μη ανατεθειμένο",
      assigned: "Ανατεθειμένο",
      make: "Κατασκευαστής",
      vehicleAppearOnceAssigned:
        "Τα οχήματα θα εμφανιστούν μόλις σας ανατεθούν!",
      searchVehicle: "Αναζήτηση οχήματος",
      trackingHistoryHrs: "Ιστορικό εντοπισμού (ώρες)",
      telemetryDevice: "Τηλεμετρική συσκευή",
      lastLocation: "Τελευταία τοποθεσία",
      latitude: "Γεωγραφικό πλάτος",
      longitude: "Γεωγραφικό μήκος",
      forSelectedPeriod: "Για την επιλεγμένη περίοδο –",
      milesDriven: "Οδηγημένα μίλια",
      engineHours: "Ώρες μηχανής",
      fuelUsageLitres: "Κατανάλωση καυσίμου (λίτρα)",
      stoppagehours: "Ώρες διακοπής",
      chargeStatus: "Κατάσταση φόρτισης",
      fuelUsage: "Κατανάλωση καυσίμου",
      batteryLevel: "Επίπεδο μπαταρίας",
      speedLimit: "Όριο ταχύτητας",
      invalidEmailAddress: "Μη έγκυρη διεύθυνση email",
      unableLoadCompanyDetails: "Αδύνατη η φόρτωση στοιχείων εταιρείας",
      bookingConfirmationProgress: "Σε εξέλιξη επιβεβαίωση κράτησης...",
      doNotHitBack:
        "Παρακαλώ μην πατήσετε πίσω, ακυρώστε ή κλείστε τον browser. Αυτή η διαδικασία μπορεί να διαρκέσει έως 2 λεπτά.",
      summary: "Περίληψη",

      addNew: "Προσθήκη νέου",
      street: "Οδός",
      city: "Πόλη",
      regionState: "Περιοχή/Νομός",
      country: "Χώρα",
      zipPostalCode: "Ταχυδρομικός Κώδικας",
      cardAuthorizeNowButAmountLater:
        "Η κάρτα θα εγκριθεί τώρα, αλλά το ποσό θα χρεωθεί όταν ξεκινήσει η κράτηση",
      saveThisCardForFutureInvoicesBooking:
        "Αποθήκευσε αυτήν την κάρτα για μελλοντικές πληρωμές τιμολογίων για αυτήν την κράτηση.",
      confirmBookingPayLater: "Επιβεβαίωση κράτησης, πληρωμή αργότερα",
      confirmBookingAndPayAtPickup:
        "Επιβεβαίωση κράτησης τώρα και πληρωμή κατά την παραλαβή",
      bookingReferenceNumber: "Αριθμός Αναφοράς Κράτησης",
      pickupDetails: "Λεπτομέρειες Παραλαβής",
      dropoffDetails: "Λεπτομέρειες Παράδοσης",
      to: "Έως",
      bookingReference: "Αναφορά Κράτησης",
      invoiceStartDate: "Ημερομηνία Έναρξης Τιμολογίου:",
      invoiceEndDate: "Ημερομηνία Λήξης Τιμολογίου:",
      availableAtLocations: "Διαθέσιμο σε Τοποθεσίες",
      benefits: "Οφέλη",
      passportNumber: "Αριθμός Διαβατηρίου",
      enterPassportNumber: "Εισαγάγετε τον αριθμό του διαβατηρίου σας",
      vehicleSwapRequest: "Αίτημα ανταλλαγής οχήματος",
      checkVehicleAvailability: "Έλεγχος διαθεσιμότητας οχήματος",
      pleaseSelectDateAndSearch:
        "Επιλέξτε ημερομηνία και πατήστε αναζήτηση για διαθεσιμότητα οχήματος",
      noVehicleFoundForSelectedDate:
        "Δεν βρέθηκε όχημα για την επιλεγμένη ημερομηνία",
      notes: "Σημειώσεις",
      writeYourNoteHere: "Γράψτε τη σημείωσή σας εδώ",
      updateRequest: "Ενημέρωση αιτήματος",
      generateRequest: "Δημιουργία αιτήματος",
      cancelRequest: "Ακύρωση αιτήματος",
      operator: "Χειριστής",
      you: "Εσείς",
      maximum: "Μέγιστο",
      imagesAreAllowed: "επιτρέπεται να ανεβάσετε εικόνες.",
      dragAndDropFile: "Σύρετε και αποθέστε ένα αρχείο ή κάντε κλικ",
      areAllowed: "επιτρέπονται",
      cancelBooking: "Ακύρωση κράτησης",
      booked: "Κρατήθηκε",
      organisation: "Οργάνωση",
      vatNumber: "Αριθμός ΦΠΑ",
      sort: "Ταξινόμηση",
      DELETE_DRIVER_DESCRIPTION:
        "Είστε σίγουροι ότι θέλετε να διαγράψετε τον οδηγό;",
      driverActions: {
        "Are you sure you want to delete the driver?":
          "Είστε σίγουροι ότι θέλετε να διαγράψετε τον οδηγό;",
        "Delete Driver": "Διαγραφή Οδηγού",
      },
      currentInvoiceStatus: {
        PAID: "ΠΛΗΡΩΘΗΚΕ",
        UNPAID: "ΑΠΛΗΡΩΤΟ",
        VOID: "ΑΚΥΡΟ",
        "PARTIALLY PAID": "ΜΕΡΙΚΩΣ ΠΛΗΡΩΘΗΚΕ",
        DRAFT: "ΠΡΟΣΧΕΔΙΟ",
      },
      currentBookingStatus: {
        CANCELLED: "ΑΚΥΡΩΘΗΚΕ",
        COMPLETED: "ΟΛΟΚΛΗΡΩΘΗΚΕ",
        "CONFIRMATION IN PROCESS": "ΕΠΙΒΕΒΑΙΩΣΗ ΣΕ ΕΞΕΛΙΞΗ",
        CONFIRMED: "ΕΠΙΒΕΒΑΙΩΜΕΝΟ",
        "IN PROGRESS": "ΣΕ ΕΞΕΛΙΞΗ",
        QUOTE: "ΠΡΟΣΦΟΡΑ",
        DRAFT: "ΠΡΟΣΧΕΔΙΟ",
        "REQUIRES APPROVAL": "ΑΠΑΙΤΕΙ ΕΓΚΡΙΣΗ",
        DECLINED: "ΑΠΟΡΡΙΨΗ"
      },
      minBookingDurationMessage:
        "Η ελάχιστη διάρκεια κράτησης είναι {{hours}} ώρες. Παρακαλώ προσαρμόστε την ημερομηνία και ώρα παραλαβής ή επιστροφής ανάλογα.",
      maxBookingDurationMessage:
        "Η μέγιστη διάρκεια κράτησης είναι {{days}} ημέρες. Παρακαλώ προσαρμόστε την ημερομηνία και ώρα παραλαβής ή επιστροφής ανάλογα.",
      usevaletTypes: {
        Delivery: "Παράδοση",
        Collection: "Παραλαβή",
        "Delivery and Collection": "Παράδοση και Παραλαβή",
      },
      selectCollectionSlot: "Επιλέξτε Χρονοθυρίδα Παραλαβής",
      driverUnavailableNote:
        "Σημείωση: Ο οδηγός δεν είναι διαθέσιμος, παρακαλώ επικοινωνήστε με τον πάροχο ενοικίασης.",
      cancellationReasons: {
        "Requirement changed": "Άλλαξε η απαίτηση",
        Price: "Τιμή",
        Other: "Άλλο",
      },
      imagePreview: "Προεπισκόπηση Εικόνας",
      markDamage: "Σημείωση Ζημιάς",
      vehicleDamageImages: "Εικόνες Ζημιών Οχήματος",
      incidentDate: "Ημερομηνία Συμβάντος",
      incidentTime: "Ώρα Συμβάντος",
      clear: "Καθαρισμός",
      bookingStatus: "Κατάσταση κράτησης",
      daysInBooking: "Ημέρες στην κράτηση",
      accumulatedDays: "συσσωρευμένες ημέρες",
      endingThisMonth: "Τερματίζοντας αυτό το μήνα",
      creditUtilisation: "Αξιοποίηση πίστωσης",
      creditLimit: "Όριο πίστωσης",
      utilized: "Χρησιμοποιούμενος",
      totalDrivers: "Συνολικός οδηγός",
      vehiclesAllocated: "Διατίθενται οχήματα",
      mileageOverview: "Επισκόπηση χιλιομέτρων",
      mileageLimitExited: "Το όριο των χιλιομέτρων εξέρχεται",
      approachingMileageLimits: "Πλησιάζοντας τα όρια των χιλιομέτρων",
      motReminders: "Υπενθυμίσεις",
      totalMotTests: "Συνολικές δοκιμές MOT",
      healthCheckReminders: "Υπενθυμίσεις ελέγχου υγείας",
      totalHealthCheckTests: "Συνολικές εξετάσεις υγειονομικού ελέγχου",
      failed: "Αποτυχημένος",
      serviceReminders: "Υπενθυμίσεις υπηρεσίας",
      overdue: "Εκπρόθεσμος",
      totalServiceReminders: "Συνολικές υπενθυμίσεις υπηρεσιών",
      createNewServiceRequest: "Δημιουργία Νέου Αιτήματος Εξυπηρέτησης",
      serviceDetails: "Λεπτομέρειες Εξυπηρέτησης",
      selectedVehicle: "Επιλεγμένο Όχημα",
      serviceRequestSelectVehicle: "Επιλέξτε Όχημα",
      loadingVehicles: "Φόρτωση οχημάτων...",
      noActiveVehiclesFound: "Δεν βρέθηκαν ενεργά οχήματα",
      addDetails: "Προσθήκη Λεπτομερειών",
      addItems: "Προσθήκη Στοιχείων",
      issueType: "Τύπος Προβλήματος",
      issueTypePlaceholder: "π.χ., Σπασμένη Κλειδαριά",
      descriptionPlaceholder: "π.χ., Κλειδαριά μπροστινής αριστερής πόρτας",
      uploaded: "Μεταφορτώθηκε",
      additionalComments: "Πρόσθετα Σχόλια",
      additionalCommentsPlaceholder: "Προσθέστε οποιαδήποτε πρόσθετη πληροφορία...",
      submitting: "Υποβολή...",
      submitRequest: "Υποβολή Αιτήματος",
      serviceRequestNote: "Το αίτημά σας θα εξεταστεί από την ομάδα εξυπηρέτησης. Θα λάβετε ειδοποίηση μόλις εγκριθεί ή εάν χρειάζονται πρόσθετες πληροφορίες.",
      serviceRequestDetails: "Λεπτομέρειες Αιτήματος Εξυπηρέτησης",
      createdDate: "Ημερομηνία Δημιουργίας",
      estimatedCost: "Εκτιμώμενο Κόστος",
      requestProgress: "Πρόοδος Αιτήματος",
      issuesReported: "Αναφερόμενα Προβλήματα",
      issue: "Πρόβλημα",
      imageAlt: "Εικόνα",
      serviceProvider: "Πάροχος Υπηρεσιών",
      appointment: "Ραντεβού",
      at: "στις",
      estimatedCompletion: "Εκτιμώμενη Ολοκλήρωση",
      workToBeDone: "Εργασίες προς Εκτέλεση",
      cost: "Κόστος",
      totalCost: "Συνολικό Κόστος",
      requestDeclined: "Αίτημα Απορρίφθηκε",
      communication: "Επικοινωνία",
      serviceTeam: "Ομάδα Εξυπηρέτησης",
      noCommunicationYet: "Καμία επικοινωνία ακόμα",
      addMessage: "Προσθήκη Μηνύματος",
      askQuestionPlaceholder: "Κάντε μια ερώτηση ή παρέχετε πρόσθετες πληροφορίες...",
      sending: "Αποστολή...",
      sendMessage: "Αποστολή Μηνύματος",
      additionalInformationRequested: "Ζητήθηκαν Πρόσθετες Πληροφορίες",
      provideFollowingInformation: "Παρακαλώ παρέχετε τις ακόλουθες πληροφορίες για να σας βοηθήσουμε να επεξεργαστούμε το αίτημά σας:",
      yourAnswer: "Η απάντησή σας:",
      typeAnswerHere: "Πληκτρολογήστε την απάντησή σας εδώ...",
      submitAnswers: "ΥΠΟΒΟΛΗ ΑΠΑΝΤΗΣΕΩΝ",
      approved: "Εγκρίθηκε",
      serviceRequests: "Αιτήματα Υπηρεσίας",
      scheduledServicesTitle: "Προγραμματισμένες υπηρεσίες",
      scheduledServicesBellAria: "Προβολή προγραμματισμένων υπηρεσιών οχήματος",
      noScheduledServices: "Δεν υπάρχουν προγραμματισμένες υπηρεσίες",
      approveScheduledServiceSuccess: "Η υπηρεσία εγκρίθηκε με επιτυχία",
      requestChangesSuccess: "Το αίτημα αλλαγής στάλθηκε για έγκριση",
      requestChanges: "Αίτημα αλλαγών",
      modifyServiceRequest: "Τροποποίηση αιτήματος υπηρεσίας",
      modifyDetails: "Τροποποίηση λεπτομερειών",
      vehicleAndCategory: "Όχημα και κατηγορία",
      cannotModify: "Δεν είναι δυνατή η τροποποίηση",
      appointmentDetails: "Λεπτομέρειες ραντεβού",
      time: "Ώρα",
      scheduledServiceReviewHint: "Παρακαλούμε ελέγξτε την προγραμματισμένη υπηρεσία. Εγκρίνετε εάν οι λεπτομέρειες είναι σωστές ή ζητήστε αλλαγές.",
      approveService: "Έγκριση υπηρεσίας",
      jobSheet: "Φύλλο εργασίας",
      declined: "Απορρίφθηκε",
      lastUpdated: "Τελευταία ενημέρωση",
      explainChangesPlaceholder: "Εξηγήστε γιατί χρειάζεστε αυτές τις αλλαγές...",
      submitChanges: "Υποβολή αλλαγών",
      expenses: "Έξοδα",
      filters: "Φίλτρα",
      applyFilters: "Εφαρμογή Φίλτρων",
      activeFilters: "Ενεργά Φίλτρα",
      newServiceRequest: "Νέο Αίτημα Υπηρεσίας",
      rowsPerPage: "Σειρές ανά σελίδα:",
      of: "από",
      moreThan: "περισσότερα από",
      searchServiceRequestsPlaceholder: "Αναζήτηση με αριθμό αναφοράς, όχημα ή κατάσταση...",
      selectOption: "Επιλέξτε μια επιλογή",
      selectMultiple: "Επιλέξτε μία ή περισσότερες επιλογές",
      uploadPhoto: "Ανεβάστε φωτογραφία",
      view: "Προβολή",
      typeYourResponse: "Πληκτρολογήστε την απάντησή σας",
      pleaseSelectServiceType: "Παρακαλώ επιλέξτε τύπο υπηρεσίας",
      pleaseSelectServiceCategory: "Παρακαλώ επιλέξτε κατηγορία υπηρεσίας",
      selectServiceType: "Επιλέξτε Τύπο Υπηρεσίας",
      serviceCategory: "Κατηγορία Υπηρεσίας",
      selectServiceCategory: "Επιλέξτε Κατηγορία Υπηρεσίας",
      unableToDetermineServiceBranch: "Δεν ήταν δυνατό να προσδιοριστεί το υποκατάστημα υπηρεσίας σας. Παρακαλώ δοκιμάστε ξανά αργότερα.",
      accidentDamageInformation: "Πληροφορίες Ατυχήματος / Ζημιάς",
      documentUploads: "Ανέβασμα Εγγράφων",
      adHoc: "Ad-Hoc",
      emergency: "Επείγον",
      serviceQuestionnaire: "Ερωτηματολόγιο Υπηρεσίας",
      serviceQuestionnaireDescription: "Παρακαλώ δώστε μερικές επιπλέον λεπτομέρειες ώστε η ομάδα εξυπηρέτησής μας να μπορεί να προετοιμάσει τα πάντα εκ των προτέρων.",
      selectServiceCategoryPrompt: "Επιλέξτε μια κατηγορία υπηρεσίας για να δείτε τις απαιτούμενες ερωτήσεις για αυτή την υπηρεσία.",
      noServiceQuestionsForType: "Δεν υπάρχουν επιπλέον ερωτήσεις για αυτόν τον τύπο υπηρεσίας. Μπορείτε να συνεχίσετε με το αίτημα.",
      fileUploadGuidance: "JPEG/PNG έως 5 MB ανά αρχείο.",
      optionalServiceQuestion: "Προαιρετική ερώτηση — απαντήστε αν βοηθάει την ομάδα μας.",
      requestCreated: "Αίτημα Δημιουργήθηκε",
      underReview: "Υπό Εξέταση",
      inProgress: "Σε Εξέλιξη",
      photo: "Φωτογραφία",
      hiThere: "Γεια σας,",
      serviceRequestDeclinedMessage: "Εξετάσαμε το αίτημα υπηρεσίας σας, αλλά δεν μπορούσε να εγκριθεί αυτή τη στιγμή.",
      whatWeNeed: "Αυτό που χρειαζόμαστε:",
      declineReasonGeneric: "Αυτό μπορεί να οφείλεται σε λείποντα στοιχεία, επιλεξιμότητα υπηρεσίας ή άλλες προϋποθέσεις έγκρισης.",
      declineInstruction: "Παρακαλώ εξετάστε τις πληροφορίες σας και υποβάλετε ένα νέο αίτημα μόλις γίνουν αυτές οι ενημερώσεις.",
      answered: "Απαντήθηκε",
      pendingAnswer: "Αναμονή απάντησης",
      requiredField: "Αυτή η απάντηση απαιτείται",
      questionsAnswered: "ερωτήσεις απαντήθηκαν",
      readyToSubmitChanges: "Έτοιμο για υποβολή ενημερώσεων",
      questionsUpToDate: "Όλες οι απαντήσεις είναι ενημερωμένες",
      updateAnyAnswerToResubmit: "Ενημερώστε οποιαδήποτε απάντηση παραπάνω αν χρειάζεται να στείλετε νέες πληροφορίες.",
      answerTypeText: "Κείμενο",
      answerTypeYesNo: "Ναι / Όχι",
      answerTypeDropdown: "Αναπτυσσόμενο Μενού",
      answerTypeMultiSelect: "Πολλαπλή Επιλογή",
      answerTypeFileUpload: "Ανέβασμα Φωτογραφίας",
      pendingApproval: "Εκκρεμής Έγκριση",
      awaitingMoreInformation: "Αναμονή Περισσότερων Πληροφοριών",
      closed: "Κλειστό",
      noServiceRequestsFound: "Δεν βρέθηκαν αιτήματα υπηρεσίας",
      fleetAllocation: "Κατανομή Στόλου",
      fleetAllocations: "Κατανομές Στόλου",
      userAgreement: "Συμφωνία Χρήστη",
      organisationCode: "Κωδικός Οργανισμού",
      serviceReference: "Αναφορά Υπηρεσίας",
      completionDate: "Ημερομηνία Ολοκλήρωσης",
      addTask: "Προσθήκη Εργασίας",
      noTaskFound: "Δεν βρέθηκαν εργασίες. Μπορείτε να προσθέσετε εργασίες χειροκίνητα.",
      taskName: "Όνομα Εργασίας",
      features: "Χαρακτηριστικά",
      interiorFeatures: "Εσωτερικά Χαρακτηριστικά",
      exteriorFeatures: "Εξωτερικά Χαρακτηριστικά",
      safetyAndTechnicalFeatures: "Χαρακτηριστικά Ασφάλειας και Τεχνολογίας",
      otherFeatures: "Άλλα Χαρακτηριστικά",
      privateHiresNo: "Ιδιωτική προσλήψεις όχι",
      pcoPrivateHiresHireDLNo: "Pco/ιδιωτική μίσθωση dl Όχι",
      gender: "Φύλο",
      secondaryPhoneNumber: "Δευτερεύον αριθμός τηλεφώνου",
      secondaryEmailAddress: "Δευτερεύουσα διεύθυνση email",
      driverAge: "Ηλικία οδηγού",
      licenceDuration: "Διάρκεια Άδειας",
      penaltyPoints: "Πόντοι ποινής",
      insuranceClaimsHistory: "Ιστορικό Ασφαλιστικών Απαιτήσεων",
      pcoExpiryDate: "Ημερομηνία λήξης PCO",
      state: "Κατάσταση",
      selectBookingType: "Επιλέξτε τύπο κράτησης",
      selectBookingTypeDialog: "Παρακαλώ επιλέξτε έναν από τους παρακάτω τύπους κράτησης για να συνεχίσετε",
      regularBooking: "Κανονική κράτηση",
      contactlessBooking: "Κράτηση χωρίς επαφή",
      reviewBookingDetails: "Έλεγχος στοιχείων κράτησης",
    },
    validation: {
      otpLengthMismatch: "Το μήκος του OTP πρέπει να είναι 6 χαρακτήρες",
      invalidOtp: "Μη έγκυρο OTP",
      required: "{{field}} απαιτείται",
      billingEmailInvalid: "Εισαγάγετε ένα έγκυρο email χρέωσης.",
      billingEmailRequired: "Απαιτείται email χρέωσης.",
      addressRequired: "Απαιτείται διεύθυνση",
      phoneNumberRequired: "Απαιτείται αριθμός τηλεφώνου.",
      businessNameRequired: "Απαιτείται όνομα επιχείρησης.",
      registrationNumberRequired: "Απαιτείται αριθμός εγγραφής",
      vatRequired: "Απαιτείται ΑΦΜ/Αριθμός Φορολογικής Εγγραφής",
      accountNumberRequired: "Απαιτείται αριθμός λογαριασμού",
      registeredAddressRequired: "Απαιτείται εγγεγραμμένη διεύθυνση",
      registeredAddressCountryRequired: "Απαιτείται χώρα",
      registeredAddressStateRequired: "Απαιτείται κατάσταση",
      registeredAddressCityRequired: "Απαιτείται πόλη",
      registeredAddressStreetRequired: "Απαιτείται δρόμος",
      tradingAddressRequired: "Απαιτείται διεύθυνση συναλλαγών",
      tradingAddressCountryRequired: "Απαιτείται χώρα",
      tradingAddressStateRequired: "Απαιτείται κατάσταση",
      tradingAddressCityRequired: "Απαιτείται πόλη",
      tradingAddressStreetRequired: "Απαιτείται δρόμος",
      contactEmailRequired: "Απαιτείται επικοινωνήστε με το email.",
      firstNameRequired: "Απαιτείται όνομα.",
      middleNameRequired: "Το μεσαίο όνομα είναι υποχρεωτικό.",
      lastNameRequired: "Το επώνυμο απαιτείται.",
      locationRequired: "Απαιτείται τοποθεσία",
      streetZipcodeRequired: "Απαιτείται δρόμος/zipcode",
      emailIsRequired: "Απαιτείται το email",
      termsConditionsAccepted:
        "Οι όροι και οι προϋποθέσεις πρέπει να γίνουν αποδεκτοί",
      drivingLicenceNumberRequired: "Απαιτείται αριθμός άδειας οδήγησης",
      nationalInsuranceNumberRequired:
        "Απαιτείται αριθμός κοινωνικής ασφάλισης",
      nationalityRequired: "Η ιθαγένεια είναι υποχρεωτική",
      enterValidPhoneNumber: "Εισαγάγετε έγκυρο αριθμό τηλεφώνου.",
      enterValidEmailAddress: "Παρακαλώ εισάγετε έγκυρη διεύθυνση email",
      authorityRequired: "Η αρχή είναι υποχρεωτική",
      licenceNumberRequired: "Απαιτείται αριθμός άδειας",
      licenceExpiryDateRequired: "Απαιτείται ημερομηνία λήξης άδειας",
      expiryDateRequired: "Απαιτείται ημερομηνία λήξης",
      numberIsRequired: "Απαιτείται αριθμός",

      passwordLengthValidaion:
        "Ο κωδικός πρέπει να έχει μήκος τουλάχιστον 8 χαρακτήρες",
      passwordContainUppercase:
        "Ο κωδικός πρέπει να περιέχει τουλάχιστον ένα κεφαλαίο γράμμα",
      passwordContainLowercase:
        "Ο κωδικός πρέπει να περιέχει τουλάχιστον ένα πεζό γράμμα",
      passwordContainOneNumber:
        "Ο κωδικός πρέπει να περιέχει τουλάχιστον έναν αριθμό",
      passwordContainSpecialCharacter:
        "Ο κωδικός πρέπει να περιέχει τουλάχιστον έναν ειδικό χαρακτήρα",
      passwordMustMatch: "Οι κωδικοί πρέπει να ταιριάζουν",
      atleastOneUppercase: "Τουλάχιστον ένα κεφαλαίο γράμμα",
      atleastOneLowercase: "Τουλάχιστον ένα πεζό γράμμα",
      atleastOneNumericalChar: "Τουλάχιστον ένας αριθμητικός χαρακτήρας",
      atleastOneSpecialChar: "Τουλάχιστον ένας ειδικός χαρακτήρας",
      pleaseEnterAValidEmail: "Παρακαλώ εισάγετε ένα έγκυρο email",
      driverNotFound: "Ο οδηγός δεν βρέθηκε",
      batteryStatusNumber: "Η κατάσταση μπαταρίας πρέπει να είναι αριθμός",
      batteryStatusCantNegative:
        "Η κατάσταση μπαταρίας δεν μπορεί να είναι αρνητική",
      batteryStatusCantMoreHundred:
        "Η κατάσταση μπαταρίας δεν μπορεί να υπερβαίνει το 100%",
      batteryStatusRequired: "Απαιτείται η κατάσταση μπαταρίας",
      odometerReadingMustNumber:
        "Η ένδειξη χιλιομετρητή πρέπει να είναι αριθμός",
      odometerReadingRequired: "Απαιτείται η ένδειξη χιλιομετρητή",
      odometerMustEqualOrHigherLast:
        "Η ένδειξη πρέπει να είναι ίση ή μεγαλύτερη από την τελευταία καταγραφή",
      titleIsRequired: "Απαιτείται τίτλος.",
      damageKindIsRequired: "Απαιτείται είδος ζημιάς.",
      descriptionIsRequired: "Απαιτείται περιγραφή.",
      damageImageIsRequired: "Απαιτείται εικόνα ζημιάς.",
      professionIsRequired: "Απαιτείται επάγγελμα",
      passportNineCharacters:
        "Ο αριθμός διαβατηρίου πρέπει να έχει 9 χαρακτήρες",
      passportIsRequired: "Απαιτείται διαβατήριο",
      organisationCodeRequired: "Απαιτείται Κωδικός Οργανισμού",
      userNotFound: "Ο χρήστης δεν βρέθηκε",
      invalidPassword: "Μη έγκυρος κωδικός πρόσβασης",
      passwordLengthError: "Ο κωδικός πρόσβασης πρέπει να έχει τουλάχιστον 8 χαρακτήρες",
      customerPCONumberRequired: "Απαιτείται ο αριθμός PCO / άδειας ιδιωτικής μίσθωσης",
      genderRequired: "Το φύλο είναι υποχρεωτικό",
    },
    misc: {
      edit: "Επεξεργασία",
      logOut: "Αποσύνδεση",
      licence: "Άδεια",
      cancel: "Ακύρωση",
      save: "Αποθήκευση",
      status: {
        PENDING: "Σε αναμονή",
        APPROVED: "Εγκεκριμένο",
        DECLINED: "Απορρίφθηκε",
        IN_REVIEW: "Υπό αναθεώρηση",
      },
      delete: "Διαγραφή",
      create: "Δημιουργία",
      signIn: "Σύνδεση",
      select: "Επιλογή",
      back: "Πίσω",
      error: "Σφάλμα",
      yes: "Ναι",
      no: "Όχι",
      payConfirm: "Πληρωμή & Επιβεβαίωση",
      clickToAdd: "Κάντε κλικ για προσθήκη",
      close: "Κλείσιμο",
      download: "Λήψη",
      selectCaps: "ΕΠΙΛΟΓΗ",
      forgotPassword: "Ξεχάσατε τον κωδικό;",
      pleaseNote: "Παρακαλώ σημειώστε",
      front: "Μπροστινό",
      columnKey: {
        "#": "#",
        Particulars: "Στοιχεία",
        Quantity: "Ποσότητα",
        "Unit Price": "Τιμή Μονάδας",
        Duration: "Διάρκεια",
        "Discounted Price": "Εκπτωτική Τιμή",
        "VAT/TAX": "ΦΠΑ/Φόρος",
        Amount: "Ποσό",
      },
      columnLabelToKeyMap: {
        ITEM: "ΕΙΔΟΣ",
        DESCRIPTION: "ΠΕΡΙΓΡΑΦΗ",
        QUANTITY: "ΠΟΣΟΤΗΤΑ",
        "UNIT PRICE": "ΤΙΜΗ ΜΟΝΑΔΑΣ",
        DURATION: "ΔΙΑΡΚΕΙΑ",
        "DISCOUNTED PRICE": "ΕΚΠΤΩΤΙΚΗ ΤΙΜΗ",
        "VAT/TAX": "ΦΠΑ/ΦΟΡΟΣ",
        PRICE: "ΤΙΜΗ",
      },
      paymentColumnsKey: {
        Date: "Ημερομηνία",
        Amount: "Ποσό",
        "Mode Of Payments": "Τρόπος Πληρωμής",
        Status: "Κατάσταση",
      },
      consolidatedInvoicesColumnsKey: {
        "#": "#",
        "Invoice Reference Number": "Αριθμός Τιμολογίου",
        "Vehicle Registration Numbers": "Αριθμός(-οί) κυκλοφορίας οχήματος"
      },
      buttonKey: {
        Rentals: "Ενοικιάσεις",
        Subscriptions: "Συνδρομές",
        "Test Drive": "Δοκιμαστική Οδήγηση",
        "Contract Hire": "Σύμβαση Ενοικίασης",
      },
      subLabelKey: {
        "Book vehicle for hours and days": "Κλείστε όχημα για ώρες ή ημέρες",
        "Subscribe vehicle for weekly/monthly":
          "Εγγραφή σε όχημα εβδομαδιαία/μηνιαία",
        "Test Drive our Premium Vehicles": "Δοκιμάστε τα πολυτελή οχήματά μας",
        "Contract Hire vehicle for weekly/monthly":
          "Μίσθωση οχήματος εβδομαδιαία/μηνιαία με σύμβαση",
      },
      buttonTextKey: {
        "Subscribe Now": "Εγγραφή τώρα",
        "Book Now": "Κράτηση τώρα",
        "Contract Now": "Σύμβαση τώρα",
      },
      featuresKey: {
        "Flexible Leasing Options": "Ευέλικτες επιλογές μίσθωσης",
        "Choose the duration of your subscription as you go":
          "Επιλέξτε τη διάρκεια της συνδρομής σας εν κινήσει",
        "Change car anytime*": "Αλλαγή αυτοκινήτου οποιαδήποτε στιγμή*",
        "Home delivery option": "Επιλογή παράδοσης στο σπίτι",
        "100% digital": "100% ψηφιακό",
        "MOT and taxes": "KTEO και φόροι",
        "Without down payment": "Χωρίς προκαταβολή",
        "Vehicle Servicing": "Συντήρηση οχήματος",
      },
      adjustmentColumnKey: {
        "#": "#",
        Amount: "Ποσό",
        "Adjusted To Invoice": "Ρυθμίστηκε στο Τιμολόγιο",
        "Adjusted At": "Ρυθμίστηκε στις",
      },
      categoriesKey: {
        Knowledge: "Γνώση",
        Behavior: "Συμπεριφορά",
        Punctuality: "Ακρίβεια χρόνου",
      },
    },
    snackBar: {
      customerInfoSaved: "Οι πληροφορίες πελάτη αποθηκεύτηκαν",
      documentDeleted: "Το έγγραφο διαγράφηκε με επιτυχία",
      documentDeleteFailed: "Αποτυχία διαγραφής εγγράφου",
      documentDeleteError: "Σφάλμα κατά τη διαγραφή του εγγράφου",
      documentMarkedForDeletion:
        "Το έγγραφο έχει επισημανθεί για διαγραφή. Οι αλλαγές θα εφαρμοστούν όταν αποθηκεύσετε.",
      profileImageUploaded: "Η εικόνα προφίλ μεταφορτώθηκε με επιτυχία",
      uploadImageFormatError: "Ανεβάστε μόνο εικόνες σε μορφή .jpeg/.jpg/.png!",
      selectDocumentType: "Επιλέξτε τύπο εγγράφου",
      selectExpiryDate: "Επιλέξτε ημερομηνία λήξης εγγράφου",
      fileSizeExceeded50mb: "Το μέγεθος αρχείου υπερβαίνει το όριο των 50MB",
      fileSizeExceeded5mb: "Το μέγεθος αρχείου υπερβαίνει το όριο των 5MB",
      uploadSuccess: "Το έγγραφο μεταφορτώθηκε με επιτυχία",
      invalidUploadFormat: "Ανεβάστε μόνο αρχεία PDF, PNG, JPG ή JPEG",
      selectExpiryDateUpload:
        "Επιλέξτε ημερομηνία λήξης πριν από τη μεταφόρτωση",
      ImageUploaded: "Η εικόνα μεταφορτώθηκε με επιτυχία",
      invalidFileType: "Μη έγκυρος τύπος αρχείου. Επιτρέπονται: jpeg ή png",
      costCenterInfoMissing: "Λείπουν πληροφορίες κέντρου κόστους!",
      selectedDriverAlreadyAdded: "Ο επιλεγμένος οδηγός έχει ήδη προστεθεί.",
      driverSavedSuccessfully: "Ο οδηγός αποθηκεύτηκε με επιτυχία.",
      additionalDriverCannotBeMore:
        "Οι επιπλέον οδηγοί δεν μπορούν να είναι περισσότεροι από την ποσότητα του πρόσθετου",
      verificationStatusInReview:
        "Η κατάσταση επαλήθευσης βρίσκεται υπό έλεγχο",
      verificationStatusPending: "Η κατάσταση επαλήθευσης εκκρεμεί",
      quoteCreated: "Δημιουργήθηκε προσφορά",
      bookingCreated: "Η κράτηση δημιουργήθηκε",
      pickUpLocationEmpty: "Το σημείο παραλαβής είναι κενό",
      slotSelectionRequiredForNonNegotiable: "Απαιτείται επιλογή χρονοθυρίδας.",
      protectionPlanMandatoryForPCOBooking:
        "Το Σχέδιο Προστασίας είναι υποχρεωτικό για κράτηση PCO",
      paymentAlreadyDone: "Η πληρωμή έχει ήδη γίνει",
      fileBeingGenerated:
        "Το αρχείο δημιουργείται, παρακαλώ δοκιμάστε ξανά αργότερα",
      provideDeliveryAddress: "Παρακαλώ εισάγετε διεύθυνση παράδοσης!",
      noValidCreditReadingFound:
        "Δεν βρέθηκε έγκυρη πιστωτική αξιολόγηση για αυτή την εταιρεία.",
      noValidCreditScoreFound:
        "Δεν βρέθηκε έγκυρη πιστωτική βαθμολογία. Ίσως έχουν ξεπεραστεί τα όρια ελέγχων.",
      atleastOneLicenceImage: "Ανεβάστε τουλάχιστον μία εικόνα άδειας",
      licenceImageUploaded: "Η εικόνα άδειας ανέβηκε με επιτυχία",
      maximumTwoImageLicence:
        "Μπορούν να ανέβουν το πολύ δύο εικόνες για την άδεια!",
      imageUploadInProgress:
        "Παρακαλώ περιμένετε, γίνεται μεταφόρτωση εικόνας!",
      errorFetchingSignedUrl: "Σφάλμα κατά την ανάκτηση υπογεγραμμένου URL",
      paymentFailed: "Η πληρωμή απέτυχε, δοκιμάστε ξανά",
      paymentFailedReasonCardDetails:
        "Η πληρωμή σας απέτυχε! Ελέγξτε τα στοιχεία της κάρτας σας ή δοκιμάστε ξανά αργότερα.",
      maximumTwoImage: "Μπορούν να μεταφορτωθούν έως δύο εικόνες για",

      cancelledSuccessfully: "Ακυρώθηκε με επιτυχία",
      selectReasonForCancel: "Παρακαλώ εισάγετε τον λόγο ακύρωσης",
      streetZipcodeRequired: "Απαιτείται Οδός / Ταχυδρομικός Κώδικας",
      feedbackSaved: "Ευχαριστούμε! Τα σχόλιά σας αποθηκεύτηκαν",
      driverAlreadyAdded: "Ο οδηγός έχει ήδη προστεθεί!",
      driverRemoved: "Ο οδηγός αφαιρέθηκε με επιτυχία",
      businessCustomerDriverDeleted:
        "Ο οδηγός επαγγελματικού πελάτη διαγράφηκε.",
      errorInSavingData: "Σφάλμα κατά την αποθήκευση των δεδομένων",
      damageInformationSaved:
        "Οι πληροφορίες ζημιάς αποθηκεύτηκαν με επιτυχία.",
      errorSavingData: "Σφάλμα κατά την αποθήκευση δεδομένων",
      problemTelematicsData: "Πρόβλημα φόρτωσης δεδομένων τηλεματικής",
      verificationRequestSent: "Το αίτημα επαλήθευσης εστάλη επιτυχώς.",
      vehicleStateUpdated: "Η κατάσταση του οχήματος ενημερώθηκε",
      driverAdded: "Ο οδηγός προστέθηκε.",
      businessCustomerCreated: "Ο Επιχειρηματικός Πελάτης δημιουργήθηκε.",
      uploadOnlyImageFiles: "Παρακαλώ ανεβάστε μόνο αρχεία εικόνας (PNG, JPEG, JPG)",
      imageSizeExceed5MB: "Το μέγεθος της εικόνας δεν πρέπει να υπερβαίνει τα 5MB",
      uploadFailed: "Η μεταφόρτωση απέτυχε",
      imagesUploadedSuccessfully: "εικόνα/ες μεταφορτώθηκαν με επιτυχία!",
      failedToUploadImages: "Αποτυχία μεταφόρτωσης εικόνων. Παρακαλώ δοκιμάστε ξανά.",
      pleaseSelectVehicle: "Παρακαλώ επιλέξτε ένα όχημα",
      pleaseFillInAllIssueDetails: "Παρακαλώ συμπληρώστε όλες τις λεπτομέρειες του προβλήματος",
      serviceRequestCreatedSuccessfully: "Το αίτημα εξυπηρέτησης δημιουργήθηκε με επιτυχία! Αναφορά:",
      errorCreatingServiceRequest: "Σφάλμα κατά τη δημιουργία αιτήματος εξυπηρέτησης",
      pleaseEnterNote: "Παρακαλώ εισάγετε μια σημείωση",
      noteAddedSuccessfully: "Η σημείωση προστέθηκε με επιτυχία",
      errorAddingNote: "Σφάλμα κατά την προσθήκη σημείωσης",
      pleaseAnswerAllRemainingQuestions: "Παρακαλώ απαντήστε σε όλες τις {{count}} εναπομείνασες ερώτηση{{plural}}",
      answersSubmittedSuccessfully: "Οι απαντήσεις υποβλήθηκαν με επιτυχία! Το αίτημά σας βρίσκεται τώρα υπό εξέταση.",
      errorSubmittingAnswers: "Σφάλμα κατά την υποβολή απαντήσεων",
      serviceRequestNotFound: "Το αίτημα εξυπηρέτησης δεν βρέθηκε",
      errorLoadingServiceRequests: "Σφάλμα κατά τη φόρτωση αιτημάτων υπηρεσίας",
      oneVehicleForContactless: "Μόνο ένα όχημα μπορεί να επιλεγεί για κράτηση χωρίς επαφή",
      oneVehicleForNonContactless: "Μόνο όχημα χωρίς επαφή ή Smartcar μπορεί να επιλεγεί για κράτηση χωρίς επαφή",
      contactlessVehicleCannotBeSelected: "Όχημα χωρίς επαφή δεν μπορεί να επιλεγεί για κανονικές κρατήσεις",
      bookingDetailsCreated: "Τα στοιχεία της κράτησης δημιουργήθηκαν"
    },
  },
};